var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("count-to", {
    attrs: {
      "start-val": _vm.startVal,
      "end-val": _vm.endVal,
      duration: _vm.duration,
      autoplay: _vm.autoplay,
      decimals: _vm.decimals,
      decimal: _vm.decimal,
      separator: _vm.separator,
      prefix: _vm.prefix,
      suffix: _vm.suffix,
      useEasing: _vm.useEasing,
      easingFn: _vm.easingFn
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }